var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.pageObjectType === 'SPORT_COMPETITOR')?_c(_setup.SingleStepTeam,{attrs:{"lockedRoute":_setup.lockedRoute}}):(_setup.pageObjectType === 'SPORT_COMPETITION')?_c(_setup.SingleStepCompetition,{attrs:{"lockedRoute":_setup.lockedRoute,"competitionId":_setup.competitionId}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }